<style scoped lang="scss" type="text/scss">
    .competition-item-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #FFF;

        .competition-poster-container {
            width: 100%;
            height: 12rem;
            border-top-left-radius: .15rem;
            border-top-right-radius: .15rem;
        }

        .info-panel {
            width: 100%;
            height: 5rem;
            background-color: rgba(0, 0, 0, .85);
            box-sizing: border-box;
            padding: .5rem 1rem;
            border-bottom-left-radius: .15rem;
            border-bottom-right-radius: .15rem;

            .competition-session {
                height: 2.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 1rem;
                color: #DDD;

                .main-competition-icon {
                    margin-right: .5rem;
                    color: #FDE206;
                }
            }

            .extra-info {
                font-size: .75rem;
                height: 1.5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #AAA;
            }
        }
    }
</style>

<template>
    <functional-card class="competition-item-container"
                     @call-edit="callEdit" @call-remove="callRemove">
        <normal-image class="competition-poster-container" :src="posterUrl"></normal-image>
        <div class="info-panel">
            <div class="competition-session global-text-ellipsis">
                <i class="icon main-competition-icon" title="主赛事" v-if="info.main === IS_MAIN">&#xe61b;</i>
                {{ info.name }} - {{ info.year_text }}
            </div>
            <div class="extra-info">
                <competition-status-led :status="info.status_text"></competition-status-led>
                <span class="school-count">报名学校总数：{{ info.players_number }}</span>
            </div>
        </div>
    </functional-card>
</template>

<script>
    import NormalImage from '../../../../components/normal-image/index';
    import CompetitionStatusLed from '../../../sub-components/competition-status-led/index';
    import FunctionalCard from '../../../../components/functional-card/index';
    import {COMPETITION_MAIN_OR_NOT_VALUE_MAP} from '../../../../constant/competition-main-or-not';
    import _ from 'lodash';

    export default {
        name: '',
        props: {
            info: {
                type: Object,
                default: () => {
                }
            }
        },
        components: {
            NormalImage,
            CompetitionStatusLed,
            FunctionalCard
        },
        data () {
            return {
                IS_MAIN: COMPETITION_MAIN_OR_NOT_VALUE_MAP.YES
            };
        },
        computed: {
            imagePlaceholder () {
                return this.$store.state.imagePlaceholder;
            },
            posterUrl () {
                return _.get(this.info, 'poster.url', this.imagePlaceholder);
            }
        },
        methods: {
            callRemove (callback) {
                this.$emit('call-remove', callback);
            },
            callEdit (callback) {
                this.$emit('call-edit', callback);
            }
        }
    };
</script>
